/**
 * Adds the selected variant to cart and sends the buyer to Shopify checkout.
 */

function isCodModeEnabled() {
  return window.HydroxSeal?.codFormEnabled !== false;
}

function syncSelectedVariantToProductForm() {
  const checkedInput = document.querySelector(
    '.variant-card-picker__input:checked[data-variant-id], .desktop-package-picker__input:checked[data-variant-id]'
  );
  const variantId = checkedInput?.dataset?.variantId;
  if (!variantId) return;

  document
    .querySelectorAll('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]')
    .forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      if (input.value === String(variantId)) return;
      input.value = String(variantId);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
}

/**
 * @param {{ variantId?: string, quantity?: string, cartAddUrl?: string }} [options]
 */
function submitBuyNowToCheckout(options = {}) {
  syncSelectedVariantToProductForm();

  let variantId = options.variantId;
  if (!variantId) {
    const variantInput = document.querySelector(
      'product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    if (variantInput instanceof HTMLInputElement) variantId = variantInput.value;
  }

  const quantity = options.quantity || '1';
  if (!variantId) return;

  const form = document.createElement('form');
  form.method = 'post';
  form.action = options.cartAddUrl || '/cart/add';
  form.hidden = true;

  for (const [name, value] of Object.entries({ id: variantId, quantity, return_to: '/checkout' })) {
    const field = document.createElement('input');
    field.type = 'hidden';
    field.name = name;
    field.value = String(value);
    form.appendChild(field);
  }

  document.body.appendChild(form);
  form.submit();
}

window.syncSelectedVariantToProductForm = syncSelectedVariantToProductForm;
window.submitBuyNowToCheckout = submitBuyNowToCheckout;

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-buy-now-button]') : null;
  if (!(button instanceof HTMLElement)) return;
  if (button instanceof HTMLButtonElement && button.disabled) return;

  if (isCodModeEnabled()) return;

  event.preventDefault();

  const productForm = button.closest('product-form-component');
  const variantInput = productForm?.querySelector('input[name="id"]');
  const quantityInput = productForm?.querySelector('[ref="quantityInput"]');

  submitBuyNowToCheckout({
    variantId: variantInput instanceof HTMLInputElement ? variantInput.value : undefined,
    quantity: quantityInput instanceof HTMLInputElement ? quantityInput.value : '1',
  });
});
